import { CircularProgress } from "@mui/material";
import {
  VoiceContainer } from "./style";
import DoneIcon from '@mui/icons-material/Done';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReplayIcon from '@mui/icons-material/Replay'

export default function NewVoiceMessage(props) {

  return (
    <VoiceContainer>
      <audio src={props.audio} controls />
      {props.uploadStatus === 'uploading' && <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: '#1a90ff',
          animationDuration: '550ms',
          position: 'absolute',
          left: 40,
          bottom: '4px'
        }}
        size={12}
        thickness={4}
      />}
      {props.uploadStatus === 'uploaded' &&
        <DoneIcon
          style={{
            color: '#47a900',
            position: 'absolute',
            bottom: '8px',
            left: '40px',
            fontSize: '15px'
          }}
        />
      }
      {props.uploadStatus === 'fail' &&
      <>
        <ErrorOutlineIcon
          style={{
            color: '#d50101',
            position: 'absolute',
            bottom: '8px',
            left: '40px',
            fontSize: '15px'
          }}
        />
        <ReplayIcon
          style={{
            color: '#292929',
            position: 'absolute',
            left: '0',
            fontSize: '2rem',
            background: '#80808085',
            width: '100%',
            height: 'calc(100% - 8px)',
            borderRadius: '35px'
          }}
          onClick={props.resendVoice}
        />
        </>
      }
    </VoiceContainer>

  );
}